import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

import { Card, Table, Modal } from 'antd';

import moment from 'moment';

import './AlarmsCard.css';

const columns = (translate, longDateFormat) => [
  {
    title: translate('carView.alarms.table.columns.description'),
    dataIndex: 'description',
    render: (text, record) => (translate('carView.alarms.descriptions.' + record.code.toLowerCase()))
  },
  {
    title: translate('carView.alarms.table.columns.initialRecordedAt'),
    dataIndex: 'initialRecordedAt',
    render: text => <div>{moment(text).format(longDateFormat.L)}</div>,
    width: '100px'
  },
  {
    title: translate('carView.alarms.table.columns.initialOdometer'),
    align: 'center',
    dataIndex: 'initialOdometer',
    width: '70px'
  },
  {
    title: translate('carView.alarms.table.columns.km'),
    align: 'center',
    dataIndex: 'km',
    width: '70px'
  }
];

const serviceLevelsWithLimitedFeatures = ['light-a'];

@inject('translationsStore', 'commonStore')
@observer
export default class AlarmsCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { translationsStore, commonStore, alarms, otheralarms } = this.props;
    return (
      <Card className="AlarmsCard" style={this.props.style} id="AlarmsCard">
        <div className="header">
          <div>{translationsStore.translate('carView.alarms.title')}</div>
        </div>
        <div className="container" style={{position:"relative"}}>
          {serviceLevelsWithLimitedFeatures.includes(this.props.serviceLevel) && <div className={"CoverDiv"}/>}
          <Table
            rowClassName={record => (record.safety === true ? 'safety' : '')}
            pagination={false}
            columns={columns(translationsStore.translate.bind(translationsStore), commonStore.longDateFormat)}
            dataSource={alarms}
            rowKey={record => record.id}
          />
          {!!this.props.otheralarms && this.props.otheralarms.length > 0 && (
            <div
              onClick={() => this.setState({ showothers: true })}
              style={{
                marginTop: '10px',
                cursor: 'pointer',
                textDecoration: 'underline',
                fontWeight: 'bold'
              }}
            >
              {this.props.otheralarms.length} {translationsStore.translate('carView.alarms.otheralarms.message')}
            </div>
          )}
        </div>
        <Modal
          rowClassName={record => (record.safety === true ? 'safety' : '')}
          title={translationsStore.translate('carView.alarms.otheralarms.title')}
          width="calc(var(--tablet-width) / var(--modal-width-ratio))"
          visible={this.state.showothers}
          getContainer={() => document.getElementById('AlarmsCard')}
          footer={null}
          onCancel={() => this.setState({ showothers: false })}
          centered={true}
        >
          <Table
            pagination={false}
            columns={columns(translationsStore.translate.bind(translationsStore), commonStore.longDateFormat)}
            dataSource={otheralarms}
            rowKey={record => record.id}
          />
        </Modal>
      </Card>
    );
  }
}
